import classNames from "classnames";
import type { ChangeEvent, FC, InputHTMLAttributes } from "react";

const WvInput: FC<
  {
    onChange?: (v: string) => void;
    onDefaultChange?: (e: ChangeEvent<HTMLInputElement>) => void;
    theme?: "normal" | "error" | "valid";
    initialValue?: string | number;
  } & Omit<InputHTMLAttributes<HTMLInputElement>, "onChange">
> = ({
  theme = "normal",
  onChange,
  initialValue,
  onDefaultChange,
  ...inputAttr
}) => {
  const { className, ...rest } = inputAttr;
  return (
    <input
      type="text"
      className={classNames([
        "form-control",
        { valid: theme === "valid" },
        { error: theme === "error" },
        { "": theme === "normal" },
        className,
      ])}
      onChange={(e) => {
        onDefaultChange?.(e);
        onChange?.(e.target.value);
      }}
      defaultValue={initialValue}
      {...rest}
    />
  );
};
export default WvInput;
